import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import settings from 'settings';
import { message } from 'antd';
import { list, update } from 'actions';

const { APP_CONFIG } = settings;

const mapStateToProps = state => ({
  notifications: state.api.notifications.data.results,
  count: state.api.notifications.data.count,
  loading: state.api.notifications.inFlight
});
const mapDispatchToProps = dispatch => ({
  updateNotification(data) {
    return dispatch(update(REDUCER_KEY.notification.key, data));
  },
  loadNotifications(page = 0) {
    dispatch(list(REDUCER_KEY.notifications.key, {
      page,
      pageSize: APP_CONFIG.defaultTablePageSmallSize,
      filters: [],
      sorted: [{
        id: 'action__id',
        desc: true
      }]
    }));
  }
});

const getDisplayName = WrappedComponent => WrappedComponent.displayName || WrappedComponent.name || 'Notifications';

const Wrapper = (WrappedComponent) => {
  const HOC = ({ loadNotifications, updateNotification, ...rest }) => {
    /**
     * @description Process the notification
     * @param {number} id
     * @param {object} acknowledged_date
     * @return Promise
     */
    const acknowledge = id => updateNotification({
      id,
      acknowledged_date: new Date().toISOString()
    })
      .then(
        (response) => {
          if (response.action) {
            message.success(`Notification for Action #'${id}' acknowledged`);
          }
          else {
            message.success('Notification acknowledged');
          }
          return response;
        }
      )
      .catch(
        () => {
          message.error('Notification could not update');
          return false;
        }
      );
    return (
      <WrappedComponent loadNotifications={loadNotifications} onAcknowledge={acknowledge} {...rest} />
    );
  };

  HOC.propTypes = {
    loadNotifications: PropTypes.func,
    updateNotification: PropTypes.func
  };

  HOC.defaultProps = {
    loadNotifications() {
    },
    updateNotification() {
    }
  };

  HOC.displayName = getDisplayName(WrappedComponent);

  return HOC;
};

const NotificationsWrapper = compose(connect(mapStateToProps, mapDispatchToProps), Wrapper);

export default NotificationsWrapper;
